import _ from 'lodash'
import {UUID} from '@/plugins/common'

export default class Format {
  constructor (args = {}) {
    const defaults = {
      id: UUID.create(),
      dataFormat: {},
      colorFormats: [],
      displayFormats: []
    }
    if (args) {
      if (args.dataFormat) {
        this.dataFormat = JSON.parse(args.dataFormat)
      }
      if (args.colorFormats) {
        this.colorFormats = JSON.parse(args.colorFormats)
      }
      if (args.displayFormats) {
        this.displayFormats = JSON.parse(args.displayFormats)
      }
    }

    _.defaults(this, args, defaults)
  }
}



// WEBPACK FOOTER //
// ./src/store/report/format.js